/**
 * Audit logs API client
 */

import { getAPIClient } from './client';

export interface AuditLog {
  id: string;
  user_id?: string;
  tenant_id: string;
  project_id?: string;
  action_type: string;
  resource_type: string;
  resource_id?: string;
  question?: string;
  model_name?: string;
  model_version?: string;
  output?: string;
  success: boolean;
  error_message?: string;
  duration_ms?: number;
  access_granted: boolean;
  denial_reason?: string;
  created_at: string;
}

export interface ListAuditLogsResponse {
  logs: AuditLog[];
  total: number;
  page: number;
  page_size: number;
}

/**
 * List audit logs
 */
export async function listAuditLogs(params?: {
  tenant_id?: string;
  project_id?: string;
  user_id?: string;
  action_type?: string;
  resource_type?: string;
  start_date?: string;
  end_date?: string;
  page?: number;
  page_size?: number;
}): Promise<ListAuditLogsResponse> {
  const client = getAPIClient();
  return client.get<ListAuditLogsResponse>('/audit', { params });
}

/**
 * Get audit log details
 */
export async function getAuditLog(logId: string): Promise<AuditLog> {
  const client = getAPIClient();
  return client.get<AuditLog>(`/audit/${logId}`);
}











